import type * as THREE from "three";
import { signedArea } from "./signedArea";
import type { SelfIntersection } from "./types";

/**
 * Cuts the ring at a crossing into the two loops that meet there. `keep` is the one with the
 * larger area — the shape the user was drawing — and `discard` is the leftover to be removed.
 */
function splitAtSelfIntersection({ points, intersection }: { points: ReadonlyArray<THREE.Vector3>; intersection: SelfIntersection }): {
	keep: Array<THREE.Vector3>;
	discard: Array<THREE.Vector3>;
} {
	const { firstEdgeIndex, secondEdgeIndex, point } = intersection;

	const outerLoop = [
		...points.slice(0, firstEdgeIndex + 1).map((entry) => entry.clone()),
		point.clone(),
		...points.slice(secondEdgeIndex + 1).map((entry) => entry.clone()),
	];

	const innerLoop = [point.clone(), ...points.slice(firstEdgeIndex + 1, secondEdgeIndex + 1).map((entry) => entry.clone())];

	const isOuterBigger = Math.abs(signedArea({ points: outerLoop })) >= Math.abs(signedArea({ points: innerLoop }));

	return {
		keep: isOuterBigger ? outerLoop : innerLoop,
		discard: isOuterBigger ? innerLoop : outerLoop,
	};
}

export { splitAtSelfIntersection };
